export const jobsData = {
  marketingDirector: {
    title: "Marketing Director",
    location: "Stamford, Connecticut, United States",
    function: "<function>",
    industry: "<function>",
    hostedApplyUrl: "https://hosted-apply.qa-aws.jobtarget.com/job/Junior-Software-Engineer-wybjVJiMfpfm",
    contactEmail: "d.luis@jobtarget.com",
    description: "JobTarget is a leading company in the online job search and recruiting industry. Our team is comprised of experts in recruitment, ecommerce, and online job search. Our products are used by thousands of corporate recruiters and reach millions of job seekers. The company values work life balance, rewarding risk and creativity, and an open-minded culture. driven, and open-minded. We're perpetually in search of ways to make the job search process better, so if you if you're up for the challenge, apply and let's make it better together.",
    aboutRole: "The Junior Software Engineer will be a key member of the Software Development team by solving complicated, challenging problems with code and delivering solutions that make a real difference to job seekers and teams.",
    responsibilities: [
      "Hands-on coding, unit-testing and maintenance of projects based on system specifications and change requests provided by the product team",
      "Work closely with technical leads in building new software according to best practices",
      "Respond to requests from the development team",
      "Research, design, and write new software programs and computer operating systems",
      "Work closely with other staff, such as project managers, graphic artists, UX designers, to enhance products",
      "Investigate new technologies"
    ],
    requiredSkills: [
      "Bachelor's degree in Computer Science or related field",
      "1-3 years of experience in software development",
      "Proficiency in one or more programming languages",
      "Strong problem-solving skills",
      "Excellent communication skills"
    ]
  },
  devOpsEngineer: {
    title: "DevOps Engineer",
    location: "Stamford, Connecticut, United States",
    function: "<function>",
    industry: "<function>",
    hostedApplyUrl: "https://hosted-apply.qa-aws.jobtarget.com/job/DevOps-Engineer",
    contactEmail: "d.luis@jobtarget.com",
    description: "We are seeking a skilled DevOps Engineer to join our dynamic team. The ideal candidate will have a strong background in automation, CI/CD pipelines, and cloud infrastructure.",
    aboutRole: "As a DevOps Engineer, you will be responsible for maintaining and improving our infrastructure, implementing automation solutions, and ensuring the reliability and scalability of our systems.",
    responsibilities: [
      "Design and implement CI/CD pipelines",
      "Manage and optimize cloud infrastructure",
      "Automate deployment processes",
      "Monitor system performance and reliability",
      "Collaborate with development teams to improve deployment processes",
      "Implement security best practices"
    ],
    requiredSkills: [
      "Bachelor's degree in Computer Science or related field",
      "3+ years of DevOps experience",
      "Strong knowledge of AWS or similar cloud platforms",
      "Experience with containerization technologies",
      "Proficiency in scripting languages",
      "Strong problem-solving abilities"
    ]
  }
}; 